// https://medium.com/@htomar/adding-type-safety-to-angular-material-dialog-%EF%B8%8F-45d72b8d16b

import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DialogWrapper } from './DialogWrapper';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private config: MatDialogConfig = {
    hasBackdrop: false,
    width: '480px',
  };
  constructor(private dialog: MatDialog) {}
  public open<T extends DialogWrapper>(
    component: ComponentType<T>,
    data: { hasBackdrop?; data?: DialogData<T> } = {},
  ): MatDialogRef<T, DialogReturn<T>> {
    const r = this.dialog.open<T, DialogData<T>, DialogReturn<T>>(component, {
      ...this.config,
      data: data.data,
    });
    r.beforeClosed().subscribe(() => {
      r.componentInstance.open = false;
    });
    return r;
  }
}

type GetRefReturn<T, K extends keyof T> = T[K] extends MatDialogRef<infer refT, infer refR> ? refR : never;
type FilterRefProp<T> = {
  [K in keyof T]: T[K] extends MatDialogRef<any, any> ? K : never;
};

type PropName<T> = FilterRefProp<T>[keyof FilterRefProp<T>];

type DialogReturn<T> = GetRefReturn<T, PropName<T>>;

type DialogData<T extends DialogWrapper<any, any, any>> = 'matDialogData' extends keyof T ? T['matDialogData'] : never;
